import { render, staticRenderFns } from "./BannerSlider.vue?vue&type=template&id=1e8f0e53&scoped=true&"
import script from "./BannerSlider.vue?vue&type=script&lang=js&"
export * from "./BannerSlider.vue?vue&type=script&lang=js&"
import style0 from "./BannerSlider.vue?vue&type=style&index=0&id=1e8f0e53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8f0e53",
  null
  
)

export default component.exports